import { baseApi } from '@alltrails/redux-helpers';
import HeatmapOptionsData from '../types/HeatmapOptionsData';

const heatmapsApi = baseApi.enhanceEndpoints({}).injectEndpoints({
  endpoints: builder => ({
    getHeatmapOptionsData: builder.query<HeatmapOptionsData, void>({
      query: () => {
        return { url: '/api/alltrails/map_overlays/heatmaps/options' };
      }
    })
  })
});

export const { useGetHeatmapOptionsDataQuery } = heatmapsApi;
